"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.treemapDimensions = exports.heatmapDimensions = exports.roundChartDimensions = exports.pointyChartDimensions = exports.stackedChartDimensions = exports.defaultDimensions = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
function isStackedChart(buckets, stackBucketName) {
    var stackBucket = sdk_model_1.bucketsFind(buckets, stackBucketName);
    return stackBucket && !sdk_model_1.bucketIsEmpty(stackBucket);
}
function stackedDimensions(buckets, viewBucketName, stackBucketName) {
    var viewBucket = sdk_model_1.bucketsFind(buckets, viewBucketName);
    var viewByAttributes = viewBucket ? sdk_model_1.bucketAttributes(viewBucket) : [];
    var stackBucket = sdk_model_1.bucketsFind(buckets, stackBucketName);
    var stackByAttribute = stackBucket && sdk_model_1.bucketAttribute(stackBucket);
    return sdk_model_1.newTwoDimensional(compact_1.default([stackByAttribute]), tslib_1.__spreadArrays(viewByAttributes, [sdk_model_1.MeasureGroupIdentifier]));
}
function defaultDimensions(def) {
    return sdk_model_1.newTwoDimensional([sdk_model_1.MeasureGroupIdentifier], sdk_model_1.bucketsAttributes(def.buckets));
}
exports.defaultDimensions = defaultDimensions;
function stackedChartDimensions(def, viewBucketName, stackBucketName) {
    if (viewBucketName === void 0) { viewBucketName = sdk_ui_1.BucketNames.VIEW; }
    if (stackBucketName === void 0) { stackBucketName = sdk_ui_1.BucketNames.STACK; }
    var buckets = def.buckets;
    return isStackedChart(buckets, stackBucketName)
        ? stackedDimensions(buckets, viewBucketName, stackBucketName)
        : defaultDimensions(def);
}
exports.stackedChartDimensions = stackedChartDimensions;
function pointyChartDimensions(def) {
    return sdk_model_1.newTwoDimensional(sdk_model_1.bucketsAttributes(def.buckets), [sdk_model_1.MeasureGroupIdentifier]);
}
exports.pointyChartDimensions = pointyChartDimensions;
function roundChartDimensions(def) {
    var attributes = sdk_model_1.bucketsAttributes(def.buckets);
    return attributes.length
        ? sdk_model_1.newTwoDimensional([sdk_model_1.MeasureGroupIdentifier], attributes)
        : sdk_model_1.newTwoDimensional([], [sdk_model_1.MeasureGroupIdentifier]);
}
exports.roundChartDimensions = roundChartDimensions;
function heatmapDimensions(def) {
    var viewBucket = sdk_model_1.bucketsFind(def.buckets, sdk_ui_1.BucketNames.VIEW);
    var viewByAttributes = viewBucket ? sdk_model_1.bucketAttributes(viewBucket) : [];
    var stackBucket = sdk_model_1.bucketsFind(def.buckets, sdk_ui_1.BucketNames.STACK);
    var stackByAttribute = stackBucket ? sdk_model_1.bucketAttributes(stackBucket) : [];
    return sdk_model_1.newTwoDimensional(viewByAttributes, compact_1.default(tslib_1.__spreadArrays(stackByAttribute, [sdk_model_1.MeasureGroupIdentifier])));
}
exports.heatmapDimensions = heatmapDimensions;
function treemapDimensions(def) {
    var attributes = sdk_model_1.bucketsAttributes(def.buckets);
    return attributes.length === 1
        ? sdk_model_1.newTwoDimensional([sdk_model_1.MeasureGroupIdentifier], attributes)
        : sdk_model_1.newTwoDimensional(attributes, [sdk_model_1.MeasureGroupIdentifier]);
}
exports.treemapDimensions = treemapDimensions;
//# sourceMappingURL=dimensions.js.map